import './sidebar.scss';
import {Link, useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {NikeApp} from "@nike/nike-design-system-icons";
import {NavItem, VerticalNavbar} from "@nike/eds";
import {useUserSettings} from "../UserSettingsProvider";

export function SideBar() {
    const navigate = useNavigate()
    const location = useLocation()
    const {currentTerritories} = useUserSettings()

    const routingMap = new Map<string, string>([
        ["1", '/dashboard'],
        ["2", '/search'],
        ["3", '/exceptions'],
        ["4", '/transport-vehicles'],
        ["5", '/pod/corrections'],
        ["6", '/master-data'],
    ]);

    const {REACT_APP_POD_ENABLED_TERRITORIES} = process.env
    const podEnabledTerritories = REACT_APP_POD_ENABLED_TERRITORIES?.split(',') ?? [];

    const navItemSearch: NavItem = {id: '2', icon: 'Search', label: 'Search', active: false,};
    const navItemExceptions: NavItem = {id: '3', icon: 'AlertCircle', label: 'Exceptions', active: false,};
    const navItemTransportVehicles: NavItem = {id: '4', icon: 'Shipping', label: 'Transport Vehicles', active: false,};
    const navItemPOD: NavItem = {id: '5', icon: 'Stages', label: 'Preferential Origin Document', active: false,};
    const navDefaultItems: NavItem[] = [navItemSearch, navItemExceptions, navItemTransportVehicles];

    const [items, setItems] = useState<NavItem[]>(navDefaultItems);
    const [itemsChanged, setItemsChanged] = useState(false); // item.active changes all the time when browsing, so we need a separate flag to indicate actual item id's change

    useEffect(() => {
        const hasPod = currentTerritories?.some(t => podEnabledTerritories.includes(t));
        const updatedItems = hasPod ? [...navDefaultItems, navItemPOD] : navDefaultItems;
        if (updatedItems.length !== items.length || updatedItems.some((item, i) => item.id !== items[i]?.id)) {
            setItems(updatedItems);
            setItemsChanged(prev => !prev);
        }
    }, [currentTerritories]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleClick = (item: { id: string }) => {
        navigate(routingMap.get(item.id)!)
    }

    useEffect(() => {
        changeIconBasedOnLocation()
    }, [location.pathname, itemsChanged]) // eslint-disable-line react-hooks/exhaustive-deps

    function changeIconBasedOnLocation() {
        setItems((prevItems) =>
            prevItems.map((item) => {
                const route = routingMap.get(item.id);
                const isActive = !!(route && location.pathname.includes(route)); // always boolean

                // Check subItems
                let subItems = item.subItems;
                if (subItems) {
                    subItems = subItems.map((subItem) => {
                        const subRoute = routingMap.get(subItem.id);
                        return {
                            ...subItem,
                            active: !!(subRoute && location.pathname.includes(subRoute)), // always boolean
                        };
                    });
                    // If any subItem is active, parent should be active too
                    if (subItems.some((sub) => sub.active)) {
                        return {...item, active: true, subItems};
                    }
                }

                return {...item, active: isActive, subItems};
            })
        );
    }

    return (
        <VerticalNavbar
            appName={'Customs Compliance Hub'}
            items={items}
            navLogoSlot={
                <Link reloadDocument to='/exceptions' aria-label='logo-link'>
                    <NikeApp
                        title='Nike logo'
                        color={'var(--eds-color-brand-orange)'}
                        width={'56px'}
                        height={'64px'}
                        style={{marginTop: '6px'}}
                    />
                </Link>
            }
            onNavigate={handleClick}
        />
    )
}
